// extracted by mini-css-extract-plugin
export default {"overlay":"Xy-z","bodyOpen":"Yy-z","content":"Zy-z","header":"_y-z","close":"az-z","closeNoHeading":"bz-z"};